import SButton from "components/Common/Button"
import {
  getBusinessPartnerListApi,
  getDesignResourceApi,
  getFabricBunchBrandIdsApi,
  getFabricById,
  getFabricCompanyListApi,
  getFabricIdsApi,
  // getFabricIdsApi,
  // getFabricSeasonIdsApi,
  getFabricSeasonIdsApiV2,
  getFabricWidthNRank,
  // getFabricYearListApi,
  getFabricYearListApiV2,
  getProductDetailApi,
  getRTWProductIdsApi,
  getSeasonListApi,
  getYearListApi,
} from "helpers/corporate_orders_create_resources"
import React, { useEffect, useState, useRef } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { defaultCreatePayload, defaultSelect } from "../default-values"

import Material from "./Material"
import OrderDetail from "./OrderDetail"
import DesignNDetail from "./DesignNDetail"
import { createCorporateOrdersApi } from "helpers/corporate_orders"
import Breadcrumb from "components/Common/Breadcrumb"
import BackButton from "components/Common/BackButton"
import { useHistory } from "react-router-dom"
import Canvas from "./Canvas"
import { getImageListDropDown } from "store/rtw-canvas/action"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"
import moment from "moment"

export default function Create() {
  const dispatch = useDispatch()

  const [payload, setPayload] = useState(defaultCreatePayload)
  const getCanvasRef = useRef()

  /**************************************
   * SELECT OPTIONS
   **************************************/
  // Order Details
  const [supplierIds, setSupplierIds] = useState([])
  const [years, setYears] = useState([])
  const [seasons, setSeasons] = useState([])
  const [productIds, setProductIds] = useState([])

  const [orderDetailDisabled, setOrderDetailDisabled] = useState(false)

  // Materials
  const [fabricCompanyIds, setFabricCompanyIds] = useState([])
  const [optionBrandAndbunch, setOptionBrandAndbunch] = useState([])
  const [fabricIds, setFabricIds] = useState([])
  const [fabricSeasonIds, setFabricSeasonIds] = useState([])
  const [fabricYears, setFabricYears] = useState([])

  // design & details options
  const [models, setModels] = useState([])
  const [pleats1s, setPleats1s] = useState([])
  const [pleats2s, setPleats2s] = useState([])
  const [fronts, setFronts] = useState([])
  const [sidePockets, setSidePockets] = useState([])
  const [pissPocket1s, setPissPocket1s] = useState([])
  const [pissPocket2s, setPissPocket2s] = useState([])
  const [flaps, setFlaps] = useState([])
  const [takeOutYourBelts, setTakeOutYourBelts] = useState([])
  const [outerSideStitchs, setOuterSideStitchs] = useState([])
  const [beltLoops, setBeltLoops] = useState([])
  const [adjusters, setAjusters] = useState([])
  const [beltWidths, setBeltWidths] = useState([])
  const [hemSpecifications, setHemSpecifications] = useState([])
  const [backOfTheKnees, setBackOfTheKnees] = useState([])
  const [suspenderButtons, setSuspenderButtons] = useState([])
  const [canvas, setCanvas] = useState(null)

  /**********************************************
   *  SELECT VALUES
   ****************************************/

  // Order Details
  const [supplierId, setSupplierId] = useState(defaultSelect)
  const [year, setYear] = useState(defaultSelect)
  const [season, setSeason] = useState(defaultSelect)
  const [productId, setProductId] = useState(defaultSelect)

  // Materials
  const [brandAndBunch, setBrandAndBunch] = useState(defaultSelect)
  const [fabricCompanyId, setFabricCompanyId] = useState(defaultSelect)
  const [fabricId, setFabricId] = useState(defaultSelect)
  const [fabricSeasonId, setFabricSeasonId] = useState(defaultSelect)
  const [fabricYear, setFabricYear] = useState(defaultSelect)
  const [width, setWidth] = useState(null)
  const [rank, setRank] = useState(null)
  const [scale, setScale] = useState("")

  // design & details values
  const [model, setModel] = useState(defaultSelect)
  const [pleats1, setPleats1] = useState(defaultSelect)
  const [pleats2, setPleats2] = useState(defaultSelect)
  const [front, setFront] = useState(defaultSelect)
  const [sidePocket, setSidePocket] = useState(defaultSelect)
  const [pissPocket1, setPissPocket1] = useState(defaultSelect)
  const [pissPocket2, setPissPocket2] = useState(defaultSelect)
  const [flap, setFlap] = useState(defaultSelect)
  const [takeOutYourBelt, setTakeOutYourBelt] = useState(defaultSelect)
  const [outerSideStitch, setOuterSideStitch] = useState(defaultSelect)
  const [beltLoop, setBeltLoop] = useState(defaultSelect)
  const [adjuster, setAjuster] = useState(defaultSelect)
  const [beltWidth, setBeltWidth] = useState(defaultSelect)
  const [hemSpecification, setHemSpecification] = useState(defaultSelect)
  const [backOfTheKnee, setBackOfTheKnee] = useState(defaultSelect)
  const [suspenderButton, setSuspenderButton] = useState(defaultSelect)
  const [trigger, setTrigger] = useState(0)
  const [sums, setSums] = useState(0)
  const [nTimesPrice, setNTimesPrice] = useState(0)

  React.useEffect(() => {
    // getImageListDropdown()
    dispatch(getImageListDropDown())
  }, [])
  /**************************************
   *  ORDER DETAILS functions
   *************************************/
  const loadBusinessPartner = async () => {
    try {
      const { data } = await getBusinessPartnerListApi()
      const _suppliers = data.map(item => ({
        label: `${item.code} - ${item.name}`,
        value: item.id,
      }))
      setSupplierIds(_suppliers)
    } catch (error) {
      console.log(error)
    }
  }

  const loadYearList = async (id = supplierId) => {
    if (!id) return

    try {
      const { data } = await getYearListApi({ id })
      const _years = data.map(item => ({
        label: item,
        value: item,
      }))

      setYears(_years)
    } catch (error) {
      console.log(error)
    }
  }

  const loadSeasonList = async () => {
    try {
      const { data } = await getSeasonListApi()
      const _seasons = data.map(item => ({
        label: `${item.code} - ${item.name}`,
        value: item.id,
      }))
      setSeasons(_seasons)
    } catch (error) {
      console.log(error)
    }
  }

  const loadProductIds = async ({ supplierId }) => {
    try {
      const { data } = await getRTWProductIdsApi(supplierId)
      const _productIds = data.map(item => ({
        value: item.id,
        label: `${item.number} - ${item.name}`,
      }))
      setProductIds(_productIds)
    } catch (error) {
      console.log(error)
    }
  }

  const loadOrderDetail = async id => {
    try {
      const { data } = await getProductDetailApi({ id })
      const _supplierId = { label: data.supplierName, value: data.supplierId }
      const _year = { label: data.year, value: data.year }
      const _season = { label: data.seasonName, value: data.seasonId }

      setSupplierId(_supplierId)
      setYear(_year)
      setSeason(_season)

      const _payload = { ...payload }
      _payload["supplierId"] = data.supplierId
      _payload["year"] = data.year
      _payload["seasonId"] = data.seasonId
      setPayload(_payload)
    } catch (error) {
      console.log(error)
    }
  }

  /*******************************
   *  MATERIALS
   *********************************/

  const loadFabricCompanies = async () => {
    try {
      const { data } = await getFabricCompanyListApi()
      const _fabricCompanyIds = data.map(item => ({
        value: item.id,
        label: item.name,
      }))
      setFabricCompanyIds(_fabricCompanyIds)
    } catch (error) {
      console.log(error)
    }
  }

  const loadFabricMakers = async (id = fabricCompanyId?.value) => {
    const param = {
      fabricCompanyId: id,
    }
    try {
      const { data } = await getFabricBunchBrandIdsApi(param)

      const _fabricMakers = data.map(item => ({
        value: item.key,
        bunch: item.bunch,
        brand: item.brand,
        label: `${item.brand} - ${item.bunch}`,
        org: item,
      }))

      setOptionBrandAndbunch(_fabricMakers)
    } catch (error) {
      console.log(error)
    }
  }

  const loadFabricSeasonIds = async (fabricCompanyId, bunch, brand, year) => {
    try {
      const { data } = await getFabricSeasonIdsApiV2(
        fabricCompanyId,
        bunch,
        brand,
        year
      )
      const _fabricSeasonIds = data.map(item => ({
        label: `${item.seasonCode} - ${item.seasonName}`,
        value: item.seasonId,
      }))

      setFabricSeasonIds(_fabricSeasonIds)
    } catch (error) {
      console.log(error)
    }
  }

  const loadFabricYears = async (
    bunchAndBrand = brandAndBunch,
    id = fabricCompanyId
  ) => {
    try {
      const { data } = await getFabricYearListApiV2(
        bunchAndBrand.brand,
        bunchAndBrand.bunch,
        id?.value
      )

      const _years = data.map(item => ({
        value: item,
        label: item,
      }))

      setFabricYears(_years)
    } catch (error) {
      console.log(error)
    }
  }

  const loadFabricWidthNRank = async (
    x = fabricId?.value,
    y = fabricSeasonId?.value,
    z = fabricYear?.value
  ) => {
    if (!x || !y || !z) return
    const params = {
      fabricId: x,
      seasonId: y,
      year: z,
    }
    try {
      const { data } = await getFabricWidthNRank(params)
      setWidth(data.clothWidth)
      setRank(data.rank)
    } catch (error) {
      console.log(error)
    }
  }

  // DESIGN/DETAIL
  const loadDesignNDetail = async (path, stateHandler) => {
    try {
      const { data } = await getDesignResourceApi(path)
      const _options = data.map(item => ({
        value: item,
        label: item,
      }))
      stateHandler(_options)
    } catch (error) {
      console.log(error)
    }
  }

  const loadModel = () => loadDesignNDetail("model", setModels)
  const loadPleats1 = () => loadDesignNDetail("pleats-1", setPleats1s)
  const loadPleats2 = () => loadDesignNDetail("pleats-2", setPleats2s)
  const loadFront = () => loadDesignNDetail("front", setFronts)
  const loadSidePocket = () => loadDesignNDetail("side-pocket", setSidePockets)
  const loadPissPocket1 = () =>
    loadDesignNDetail("piss-pocket-1", setPissPocket1s)
  const loadPissPocket2 = () =>
    loadDesignNDetail("piss-pocket-2", setPissPocket2s)
  const loadFlap = () => loadDesignNDetail("flap", setFlaps)
  const loadTakeOutYourBelt = () =>
    loadDesignNDetail("take-out-your-belt", setTakeOutYourBelts)
  const loadOuterSideStitch = () =>
    loadDesignNDetail("outer-side-stitch", setOuterSideStitchs)
  const loadBeltLoop = () => loadDesignNDetail("belt-loop", setBeltLoops)
  const loadAdjuster = () => loadDesignNDetail("adjuster", setAjusters)
  const loadBeltWidth = () => loadDesignNDetail("belt-width", setBeltWidths)
  const loadHemSpec = () =>
    loadDesignNDetail("hem-specification", setHemSpecifications)
  const loadBackOfKnee = () =>
    loadDesignNDetail("back-of-the-knee", setBackOfTheKnees)
  const loadSuspenderButton = () =>
    loadDesignNDetail("suspender-button", setSuspenderButtons)

  /********************************************
   *  EVENTS
   ********************************************/

  // order details sizes and prices
  const onSizeChange = e => {
    const {
      name,
      value,
      dataset: { size: _size },
    } = e.target
    const _payload = { ...payload }
    const sizes = [...payload.sizes]
    const indexSize = sizes.findIndex(item => item.size === _size)

    sizes[indexSize][name] = value

    _payload["sizes"] = sizes

    setPayload(_payload)
    setTimeout(() => {
      calculateSums()
    }, 10)
  }

  const calculateSums = () => {
    const _sizes = [...payload.sizes]
    let _sum = 0
    let _nTimesPrice = 0

    for (let sz of _sizes) {
      _sum += +sz.orderQty
      _nTimesPrice += sz.orderQty * sz.unitPrice
    }

    setSums(_sum)
    setNTimesPrice(_nTimesPrice)
  }

  /**
   * Materials
   */

  const stateHandler = {
    supplierId: setSupplierId,
    brandAndBunch: setBrandAndBunch,
    year: setYear,
    seasonId: setSeason,
    productId: setProductId,
    fabricCompanyId: setFabricCompanyId,
    fabricId: setFabricId,
    fabricYear: setFabricYear,
    fabricSeasonId: setFabricSeasonId,
    // fabricSeasonId: setFabricSeasonId,
  }

  // all inputs except some special cases
  const handleInput = obj => {
    const _payload = { ...payload }
    switch (obj.type) {
      case "supplierId":
      case "year":
      case "brandAndBunch":
      case "seasonId":
      case "productId":
      case "fabricId":
      case "fabricYear":
      case "fabricSeasonId":
      case "fabricCompanyId":
        _payload[obj.type] = obj?.val?.value
        stateHandler[obj.type](obj?.val)
        break

      case "orderDate":
      case "scheduledDeliveryDate":
      case "deliveryDate": {
        // _payload[obj.type] = new Date(obj.e).toISOString().slice(0, 10)
        _payload[obj.type] = moment(obj.e).format("YYYY-MM-DD")
        break
      }
      case "type":
      case "color":
      case "outerMaterialComposition":
      case "picName":
      case "productName":
        _payload[obj.type] = obj.e.target?.value
        break

      case "scale":
        _payload[obj.type] = obj?.val?.target?.value
        break

      case "newProduct":
        const { name, checked } = obj.e.target
        _payload[name] = checked
        setOrderDetailDisabled(!checked)
        break

      case "sample":
        _payload[obj.type] = obj.e.target.checked
        break
    }
    setPayload(_payload)
  }

  /**
   *  Design & Details
   */

  const designStateHandlers = {
    model: setModel,
    pleats1: setPleats1,
    pleats2: setPleats2,
    front: setFront,
    sidePocket: setSidePocket,
    pissPocket1: setPissPocket1,
    pissPocket2: setPissPocket2,
    flap: setFlap,
    takeOutYourBelt: setTakeOutYourBelt,
    outerSideStitch: setOuterSideStitch,
    beltLoop: setBeltLoop,
    adjuster: setAjuster,
    beltWidth: setBeltWidth,
    hemSpecification: setHemSpecification,
    backOfTheKnee: setBackOfTheKnee,
    suspenderButton: setSuspenderButton,
  }

  const onDesignNDetailChange = ({ key, value }) => {
    designStateHandlers[key](value)
    const _payload = { ...payload }
    _payload[key] = value?.value
    setPayload(_payload)
  }
  const [activeTab, setActiveTab] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const onSubmitPress = () => {
    setIsSubmitting(true)

    setActiveTab(1)
    setTimeout(() => {
      onSubmit()
    }, 1000)
  }

  const onSubmit = async () => {
    try {
      const getCanvas = await getCanvasRef.current.saveCanvas()

      setTimeout(async () => {
        const _payload = {
          ...payload,
          sizes: payload.sizes.filter(size => size.orderQty),
          image: getCanvas?.details[0].image ?? "",
          json: getCanvas?.details[0].json ?? {},
        }
        await createCorporateOrdersApi(_payload)
        setIsSubmitting(false)
        localStorage.removeItem("canvasCorporateOrder")
        window.location.href = "/corporate-orders"
      }, (getCanvas?.details.length || 2) * 1000)
    } catch (error) {
      console.log(error)
      setIsSubmitting(false)
      toast.error(error?.response?.data?.message || "Error server")
    }
  }

  /****************************************
   * POST RENDER
   ******************************************/

  useEffect(() => {
    loadBusinessPartner()
    loadSeasonList()
    // loadProductIds()
    loadFabricCompanies()
    loadModel()
    loadPleats1()
    loadPleats2()
    loadFront()
    loadSidePocket()
    loadPissPocket1()
    loadPissPocket2()
    loadFlap()
    loadTakeOutYourBelt()
    loadOuterSideStitch()
    loadBeltLoop()
    loadAdjuster()
    loadBeltWidth()
    loadHemSpec()
    loadBackOfKnee()
    loadSuspenderButton()
  }, [])

  useEffect(() => {
    if (fabricCompanyId?.value && fabricYear?.value && brandAndBunch?.value) {
      loadFabricSeasonIds(
        fabricCompanyId?.value,
        brandAndBunch.bunch,
        brandAndBunch.brand,
        fabricYear?.value
      )
    }
  }, [fabricCompanyId, fabricYear, brandAndBunch])

  useEffect(() => {
    if (payload.supplierId) {
      loadProductIds({
        supplierId: supplierId?.value,
      })
    }
  }, [supplierId])

  useEffect(() => {
    if (fabricCompanyId?.value) {
      loadFabricMakers()
    }
  }, [fabricCompanyId])

  useEffect(() => {
    if (brandAndBunch?.value) {
      loadFabricYears()
    }
  }, [brandAndBunch])

  const loadFabric = async (brand, bunch, id) => {
    const param = {
      brand: brand,
      bunch: bunch,
      fabricCompanyId: id,
    }
    const { data } = await getFabricIdsApi(param)
    const _fabricIds = data.map(item => ({
      value: item.id,
      label: item.number,
    }))

    setFabricIds(_fabricIds)
  }

  useEffect(() => {
    if (brandAndBunch?.value && fabricCompanyId?.value) {
      loadFabric(
        brandAndBunch.brand,
        brandAndBunch.bunch,
        fabricCompanyId?.value
      )
    }
  }, [brandAndBunch, fabricCompanyId])

  const loadFabricById = async id => {
    const { data } = await getFabricById(id)

    setWidth(data.clothWidth)
  }

  useEffect(() => {
    if (fabricId?.value && fabricYear?.value && fabricSeasonId?.value) {
      loadFabricWidthNRank()
    } else if (fabricId?.value) {
      loadFabricById(fabricId?.value)
    }
  }, [fabricId, fabricYear, fabricSeasonId])

  const config = {
    supplierId,
    supplierIds,
    orderDetailDisabled,
    year,
    years,
    season,
    seasons,
    payload,
    productId,
    productIds,
    setProductId, // untuk clear
    setFabricYear, // untuk clear
    setFabricId, // untuk clear
    setFabricSeasonId, // untuk clear
    setBrandAndBunch, // untuk clear
    setWidth, // untuk clear
    setRank,
    setScale,
    scale,
    onSizeChange,
    fabricCompanyId,
    fabricCompanyIds,
    fabricId,
    fabricIds,
    brandAndBunch,
    optionBrandAndbunch,
    fabricSeasonId,
    fabricSeasonIds,
    fabricYear,
    fabricYears,
    width,
    rank,
    model,
    models,
    onDesignNDetailChange,
    pleats1,
    pleats1s,
    pleats2,
    pleats2s,
    front,
    fronts,
    sidePocket,
    sidePockets,
    pissPocket1,
    pissPocket1s,
    pissPocket2,
    pissPocket2s,
    flap,
    flaps,
    takeOutYourBelt,
    takeOutYourBelts,
    outerSideStitch,
    outerSideStitchs,
    beltLoop,
    beltLoops,
    adjuster,
    adjusters,
    beltWidth,
    beltWidths,
    hemSpecification,
    hemSpecifications,
    backOfTheKnee,
    backOfTheKnees,
    suspenderButton,
    suspenderButtons,
    handleInput,
    sums,
    nTimesPrice,
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="新規RTW法人受注" breadcrumbList={[]} />
        <Row className="d-flex my-2">
          <Col sm={5}>
            <SButton
              style={{ width: 150, borderRadius: 0 }}
              className={`${activeTab === 0 ? "button-active" : "button"}`}
              onClick={() => setActiveTab(0)}
            >
              受注詳細
            </SButton>
            <SButton
              style={{ width: 150, borderRadius: 0 }}
              className={`${activeTab === 1 ? "button-active" : "button"}`}
              onClick={() => setActiveTab(1)}
            >
              手書きノート
            </SButton>
          </Col>
          <Col sm={7} className="d-flex justify-content-end">
            <SButton
              loading={isSubmitting}
              onClick={onSubmitPress}
              className="button"
            >
              保存
            </SButton>
            <BackButton className="ms-2 button" />
          </Col>
        </Row>

        {activeTab === 0 ? (
          <>
            <Card>
              <CardBody>
                <OrderDetail config={config} />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row>
                  <Col xl={5} sm={8}>
                    <Material config={config} />
                    <DesignNDetail config={config} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </>
        ) : (
          // <p>手書きノート ini</p>
          <Canvas
            setCanvas={v => setCanvas(v)}
            trigger={trigger}
            ref={getCanvasRef}
          />
        )}
      </Container>
    </div>
  )
}
